export const GET_INFO_TRADER = "GET_INFO_TRADER";
export const SET_INFO_TRADER = "SET_INFO_TRADER";
